import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { getMessage } from 'util/locale';

// constants
import { advancedScriptRequirements } from 'constants/advanced';

// components
import { Card } from '@tcc/crate';
import MinimumRequirementsErrorModalContainer from 'common/modals/MinimumRequirementsErrorModalContainer';
import CropSelectionDoesNotMeetModalContainer from 'common/modals/CropSelectionDoesNotMeetModalContainer';
import LayerInclusionModalContainer from 'common/modals/LayerInclusionModalContainer';
import HistoryTableMultiSeason from './multi-season/HistoryTable';
import RemoveLayers from './RemoveLayers';
import UploadYieldInfo from './UploadYieldInfo';

const baseString = 'vra-meets-requirements';

const MeetsRequirements = ({
  advancedScriptRequirementsMatch,
  cropList,
  historyRows,
  isAppMode,
  onSelectCropForSeason,
  onSelectDateForSeason,
  onToggleLayerInclusion
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'vra-route-container--app-mode': isAppMode
  });
  const uploadYieldInfo = (advancedScriptRequirementsMatch === advancedScriptRequirements.MEETS_WITH_YIELD_ONLY)
    ? null : (
      <UploadYieldInfo
        text={ getMessage('help-text__upload-yield-info') }
      />
    );

  const requirementInfoClassString = classNames({
    [`${baseString}__requirement-info`]: true,
    'vra-review-harvest-history__requirement-info': true
  });
  const historyPanelClassString = classNames({
    [`${baseString}__history-panel`]: true,
    'vra-review-harvest-history__history-panel': true,
    'vra-review-harvest-history-multi-season__history-panel': true
  });

  return (
    <section className={classString} data-test-id='vra-meets-requirements'>
      <div>
        <section className={requirementInfoClassString} data-test-id='vra-meet-requirement-info'>
          {getMessage('help-text__harvest-history__requirement-info', { numLayers: historyRows.length })}
        </section>
        <RemoveLayers historyRows={historyRows}/>
      </div>
      <Card className={historyPanelClassString}>
        <HistoryTableMultiSeason
          cropList={cropList}
          historyRows={historyRows}
          isAppMode={isAppMode}
          onSelectCropForSeason={onSelectCropForSeason}
          onSelectDateForSeason={onSelectDateForSeason}
          onToggleLayerInclusion={onToggleLayerInclusion}
        />
        {uploadYieldInfo}
        <section className={`${baseString}__missing-yield-data`}>
          <p>{getMessage('help-text__missing-yield-data')}</p>
        </section>
      </Card>
      <LayerInclusionModalContainer />
      <CropSelectionDoesNotMeetModalContainer />
      <MinimumRequirementsErrorModalContainer />
    </section>
  );
};

MeetsRequirements.propTypes = {
  advancedScriptRequirementsMatch: propTypes.oneOf(Object.values(advancedScriptRequirements)),
  cropList: propTypes.object.isRequired,
  historyRows: propTypes.array.isRequired,
  isAppMode: propTypes.bool.isRequired,
  onSelectCropForSeason: propTypes.func.isRequired,
  onSelectDateForSeason: propTypes.func.isRequired,
  onToggleLayerInclusion: propTypes.func.isRequired
};

export default MeetsRequirements;
